import { getRuntimeConfig } from '@zagru/platform';
import { BrandWordmark } from '@zagru/design-system';

export interface WordmarkProps {
  /** `onDark` for Prussian surfaces (navigation rail, sign-in panel). */
  tone?: 'onLight' | 'onDark';
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

/**
 * The Zagru One name as it appears in the product: the design system's `BrandWordmark`, fed with the approved
 * artwork a deployment configures (`branding.logoUrl` for light surfaces, `branding.logoOnDarkUrl` for Prussian
 * surfaces; see docs/ui-ux/ZAGRU-ONE-DESIGN-SYSTEM.md §Brand assets). The identity pages draw the same component.
 */
export function Wordmark({ tone = 'onLight', size = 'md', className }: WordmarkProps) {
  const branding = (getRuntimeConfig() as { branding?: { logoUrl?: string; logoOnDarkUrl?: string } }).branding;
  const src = tone === 'onDark' ? branding?.logoOnDarkUrl : branding?.logoUrl;
  return <BrandWordmark tone={tone} size={size} {...(src ? { src } : {})} {...(className ? { className } : {})} />;
}
